import styled from "styled-components";
import { Drawer as DrawerAnt, Input } from "antd";
import { Close, Trash2Outline } from "../../styles/Icons";

export const Drawer = styled(DrawerAnt)`
  .ant-drawer-content {
    border-radius: 12px 0 0 12px;
  }
`;

export const WelcomeContent = styled.div`
  display: flex;
  background: var(--orange-gradient-chatbot);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 92%;
  padding: 24px;
  text-align: center;
  color: white;
`;

export const AvatarImage = styled.img`
  width: 150px;
  height: 150px;
  font-size: 18px;
  margin-bottom: 24px;
  border: 4px solid white;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 32px;
  border-radius: 50%;
  object-fit: cover;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  color: white;
  margin-bottom: 1rem;
`;

export const Description = styled.p`
  color: white;
  font-size: 1rem;
  margin-bottom: 2rem;
  max-width: 300px;
  line-height: 1.6;
  word-wrap: break-word;
`;

export const StartButton = styled.button`
  background: white;
  color: var(--orange-400);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  padding: 12px 32px;
  height: auto;
  letter-spacing: 0.8px;
`;

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  flex: 1;
  overflow-y: auto;
`;

export const WrapperChat = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

export const ChatHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 8%;
  padding: 1rem;
  font-size: 1rem;
  border-bottom: 1px solid rgba(5, 5, 5, 0.06);
  background-color: white;
`;

export const LeftHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 90%;
`;

export const CloseIcon = styled(Close)`
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.45);
`;

export const ButtonTrash = styled.button`
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10%;
`;

export const TrashIcon = styled(Trash2Outline)`
  width: 1rem;
  height: 1rem;
  color: rgba(0, 0, 0, 0.45);
`;

export const HeaderAvatar = styled.img`
  width: 2rem;
  height: 2rem;
  border: 2px solid var(--orange-400);
  border-radius: 50%;
`;

export const HeaderName = styled.span`
  font-weight: 500;
  font-size: 1rem;
  color: var(--gray-800);
`;

export const MessagesWrapper = styled.div`
  flex: 1;
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ChatFooter = styled.div`
  display: flex;
  padding: 12px 16px;
  gap: 8px;
  background-color: white;
  border-top: 1px solid var(--white-25);
`;

export const ChatInput = styled(Input)`
  flex: 1;
  height: 45px !important;
`;

export const MessageBlock = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const MessageBody = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 4px;
`;

export const MessageAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
`;

export const MessageName = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--gray-650);
  margin-bottom: 2px;
`;

export const MessageContent = styled.div<{ isUser: boolean }>`
  background-color: ${(props) => (props.isUser ? "var(--gray-20)" : "white")};
  padding: 10px 14px;
  border-radius: 8px;
  box-shadow: ${(props) =>
    props.isUser ? "none" : "0px 2px 6px rgba(0, 0, 0, 0.05)"};
  border: ${(props) => (props.isUser ? "1px solid var(--gray-100)" : "none")};
  font-size: 14px;
`;

export const TypingIndicator = styled.p`
  font-size: 0.875rem;
  color: var(--gray-350);
  text-align: center;
  margin: 8px 0 0;
`;
